export default __webpack_public_path__ + "static/media/gallery_02.7f5be52a.jpg";